import { render, staticRenderFns } from "./Agregar-enlace.vue?vue&type=template&id=74ee12ca&"
import script from "./Agregar-enlace.vue?vue&type=script&lang=js&"
export * from "./Agregar-enlace.vue?vue&type=script&lang=js&"
import style0 from "./Agregar-enlace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports